<template>
  <div id="app-center">
    <home-head></home-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="center-left">
              <p class="register_head">
                机构信息（请填写注册信息并提交注册）：
                <span class="login">
                  <i class="el-icon-info"></i> 已有账号？
                  <router-link to="/unitLogin">去登录</router-link>
                </span>
              </p>

              <el-form
                :model="unitForm"
                :rules="rules"
                ref="unitRef"
                label-width="120px"
                class="demo-unitForm"
              >
                <el-row :gutter="20">
                  <el-col :span="10" :offset="2">
                    <el-form-item label="机构名称" prop="unit_name">
                      <el-input v-model="unitForm.unit_name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <!-- <el-form-item label="联系方式" prop="unit_contact">
                      <el-input v-model="unitForm.unit_contact"></el-input>
                    </el-form-item>-->
                    <el-form-item label="公益负责人" prop="public_master">
                      <el-input v-model="unitForm.public_master" placeholder="公益事务负责人"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="10" :offset="2">
                    <el-form-item label="机构负责人" prop="unit_master">
                      <el-input v-model="unitForm.unit_master" placeholder="机构CEO姓名"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="负责人手机号" prop="unit_master_contact">
                      <el-input v-model="unitForm.unit_master_contact" :maxlength="20"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="20" :offset="2">
                    <el-form-item label="机构代码证号" prop="practice_license">
                      <el-input v-model="unitForm.practice_license" :maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="10" :offset="2">
                    <el-form-item label="医保资格" prop="quality">
                      <el-select v-model="unitForm.quality">
                        <el-option label="是" :value="1"></el-option>
                        <el-option label="否" :value="2"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <el-col :span="10">
                    <el-form-item label="体系" prop="system_type">
                      <el-select v-model="unitForm.system_type" placeholder="请选择体系">
                        <el-option
                          :label="item.text"
                          :value="item.value"
                          v-for="(item,index) in system_type_list"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20" v-show="unitForm.quality==1">
                  <el-col :span="20" :offset="2">
                    <el-form-item label="医保附件" prop="quality_pic_ids">
                      <el-upload
                        ref="picRef"
                        :action="uploadImgUrl"
                        list-type="picture-card"
                        :on-preview="showImg"
                        :data="uploadParms"
                        name="img"
                        :before-upload="beforeUpload"
                        :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,'defImgs');
                    }"
                        :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,'defImgs');
                    }"
                        multiple
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="20" :offset="2">
                    <el-form-item label="机构地址" prop="province_id">
                      <el-select
                        v-model="unitForm.province_id"
                        placeholder="请选择省份"
                        @change="getCity"
                        :popper-append-to-body="false"
                      >
                        <el-option
                          v-for="item in provinceLists"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-model="unitForm.city_id"
                        placeholder="请选择城市"
                        @change="getCounty"
                        :clearable="true"
                        :popper-append-to-body="false"
                      >
                        <el-option
                          v-for="item in cityLists"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                      <el-select
                        v-model="unitForm.county_id"
                        placeholder="请选择县/区"
                        :clearable="true"
                        :popper-append-to-body="false"
                      >
                        <el-option
                          v-for="item in countyLists"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="20" :offset="2">
                    <el-form-item label="详细地址">
                      <el-input type="textarea" v-model="unitForm.unit_address"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <p class="register_head">管理员信息：</p>
                <el-row :gutter="20">
                  <el-col :span="10" :offset="2">
                    <el-form-item label="联系人：" prop="user_name">
                      <el-input
                        v-model="unitForm.user_name"
                        style="width: 90%"
                        placeholder="请输入联系人姓名"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="职务：" prop="duties">
                      <el-input v-model="unitForm.duties" placeholder="请输入联系人职务" style="width: 90%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="10" :offset="2">
                    <el-form-item label="联系邮箱：" prop="email">
                      <el-input v-model="unitForm.email" style="width: 90%" placeholder="请输入联系人邮箱"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="手机号码：" prop="phone">
                      <el-input
                        v-model="unitForm.phone"
                        placeholder="手机号码将作为登录账号"
                        onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                        style="width: 90%"
                      >
                        <el-button
                          slot="append"
                          @click="sendSmsCode"
                          :disabled="disabledCode"
                        >{{codeText}}</el-button>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="10" :offset="2">
                    <el-form-item label="验证码：" prop="code">
                      <el-input
                        v-model="unitForm.code"
                        placeholder="请输入短信验证码"
                        onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                        style="width: 90%"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="密码：">
                      <el-input
                        type="password"
                        v-model="unitForm.password"
                        placeholder="请输入密码，为空默认手机号码后六位"
                        style="width: 90%"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item
                  style="text-align: right; margin: 20px; padding: 20px; border-top:1px solid #ccc"
                >
                  <router-link to="/unitLogin">
                    <el-button type="default" size="medium">返回登录</el-button>
                  </router-link>
                  <el-button
                    type="primary"
                    style="margin-top: 20px"
                    icon="el-icon-success"
                    @click="onSubmit"
                    :loading="loading"
                    size="medium"
                  >注册并登录</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-dialog :visible.sync="img_show" append-to-body>
        <img width="100%" :src="img_url" alt />
      </el-dialog>
      <div class="center-footer">
        <div class="footer-content">
          <span>（建议您使用IE9及以上版本浏览器访问本网站）</span>
          <span>技术支持：长沙普益云软件科技有限公司</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import homeHead from "../Public/head";

export default {
  components: {
    homeHead
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(value)) {
        return callback(new Error("手机号码格式不正确！"));
      } else {
        return callback();
      }
    };

    var checkRegion = (rule, value, callback) => {
      if (!this.unitForm.county_id && this.unitForm.if_china == 1) {
        return callback(new Error("请选择单位地址"));
      } else {
        return callback();
      }
    };

    return {
      loading: false,
      is_error: false,
      uploadImgUrl: "", //上传图片接口url
      img_url: "", //图片预览路径
      img_show: false, //图片预览弹窗
      uploadParms: { file_type: 2 }, //图片上传所需参数

      defImgs: [],

      provinceLists: [], //省集合
      cityLists: [], //市集合
      countyLists: [], //县集合
      system_type_list: [],

      codeText: "获取验证码", //
      disabledCode: false,

      unitForm: {
        unit_name: null, //机构名称
        // unit_contact: null, //机构联系方式
        unit_master: null, //执行机构负责人
        unit_master_contact: null, //执行机构负责人联系方式
        system_type: null, //体系
        practice_license:'',
        quality: null, //是否医保资格
        quality_pic_ids: [], //医保附件多图上传
        province_id: null,
        city_id: null,
        county_id: null,
        unit_address: "" //详细地址
      },
      rules: {
        unit_name: [
          { required: true, message: "请输入单位名称", trigger: "blur" }
        ],
        // unit_contact: [
        //   { required: true, message: "请输入机构联系方式", trigger: "blur" }
        // ],
        unit_master: [
          { required: true, message: "请输入执行机构负责人", trigger: "blur" }
        ],
        unit_master_contact: [
          {
            required: true,
            message: "请输入执行机构负责人联系方式",
            trigger: "blur"
          },
          { validator: checkPhone, trigger: "blur" }
        ],

        practice_license: [
          { required: true, message: "请输入机构代码证号 ", trigger: "blur" }
        ],
        system_type: [
          {
            required: true,
            type: "number",
            message: "请输入执业许可证",
            trigger: "change"
          }
        ],

        public_master: [
          { required: true, message: "请输入公益事务负责人", trigger: "blur" }
        ],

        user_name: [
          { required: true, message: "请输入联系人名称", trigger: "blur" }
        ],
        duties: [
          { required: true, message: "请输入联系人职务", trigger: "blur" }
        ],
        email: [{ type: "email", message: "邮箱格式不正确", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        province_id: [
          { required: true, message: "请选择机构地址", trigger: "change" },
          { validator: checkRegion, trigger: "change" }
        ]
      }
    };
  },
  methods: {
    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    sendSmsCode() {
      //发送验证码
      // if (this.is_error) {
      //   this.$message.warning("该地区已存在医院！");
      //   return false;
      // }
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(this.unitForm.phone)) {
        return this.$message({
          type: "warning",
          message: "请输入正确的手机号码！"
        });
      } else {
        this.$db
          .post(this.$db.config.checkPhoneHas, { phone: this.unitForm.phone })
          .then(res => {
            if (res.code == 200 && !res.data) {
              var second = 60;
              var self = this;
              // 定时器
              var codeLimit = setInterval(function() {
                self.disabledCode = true;
                second--;
                self.codeText = second + "秒";
                if (second == 0) {
                  clearInterval(codeLimit);
                  self.disabledCode = false;
                  self.codeText = "发送验证码";
                }
              }, 1000);
              this.$db
                .post(this.$db.config.sendCodeUrl, {
                  mobile: this.unitForm.phone
                })
                .then(res => {
                  if (res.code == 200) {
                    return this.$message.success(res.msg);
                  }
                });
            }
          });
      }
    },

    //预览图片
    showImg(file) {
      this.img_url = file.response.data.imgPath;
      this.img_show = true;
    },

    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    onSubmit() {
      //表单提交
      // if (this.is_error) {
      //   this.$message.warning("该地区已存在医院！");
      //   return false;
      // }

      this.$refs["unitRef"].validate(valid => {
        if (valid) {
          this.loading = true;
          let pic = this.defImgs;
          if (pic.length > 0) {
            let arr = [];
            for (let item of pic) {
              if (item.hasOwnProperty("response")) {
                arr.push(item.response.data.id);
              } else {
                arr.push(item.id);
              }
            }
            this.unitForm.quality_pic_ids = arr;
          }

          this.$db
            .post(this.$db.config.registerUnitUrl, this.unitForm)
            .then(res => {
              this.loading = false;
              let pwd;
              if (this.unitForm.password) {
                pwd = this.unitForm.password;
              } else {
                pwd = this.unitForm.phone.toString().slice(5);
              }

              if (res.code == 200) {
                this.$message.success(res.msg);
                this.$db
                  .post(this.$db.config.doUnitLoginUrl, {
                    phone: this.unitForm.phone,
                    password: pwd
                  })
                  .then(res => {
                    if (res && res.code == 200) {
                      sessionStorage.setItem("token", res.data["access-token"]);
                      this.getUserInfo();
                    }
                  });
              }
            });
        } else {
          this.$message.warning("请填写完整信息！");
          return false;
        }
      });
    },
    getUserInfo() {
      //根据token获取用户信息
      this.$db.post(this.$db.config.getUserInfoByToken, {}).then(res => {
        if (res.code == 200) {
          let data = {};
          data = res.data;
          data.timestamp = new Date().getTime();
          let userInfo = JSON.stringify(data);
          sessionStorage.setItem("unitAuth", userInfo);
          sessionStorage.removeItem("unitChannelName");
          this.$router.push({ name: "unitInfoSet" });
        }
      });
    },

    getCity(value) {
      this.unitForm.city_id = null;
      this.unitForm.county_id = null;

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 2, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.cityLists = resp.data;
          }
        });
    },
    getCounty(value) {
      this.unitForm.county_id = null;

      this.$db
        .post(this.$db.config.getRegionUrl, { level: 3, pid: value })
        .then(resp => {
          if (resp && resp.code == 200) {
            this.countyLists = resp.data;
          }
        });
    },

    //检测该地区是否注册了医院
    checkRegionUnit(value) {
      if (value) {
        this.$db
          .post(this.$db.config.getCheckRegion, {
            province_id: this.unitForm.province_id,
            city_id: this.unitForm.city_id,
            county_id: this.unitForm.county_id
          })
          .then(resp => {
            if (resp && resp.code == 200) {
              this.is_error = false;
            } else {
              this.is_error = true;
            }
          });
      }
    },

    //获取体系字典
    getSystemType() {
      this.$db
        .post(this.$db.config.getDictParam, {
          pid: 200601,
          table: "pub_dict"
        })
        .then(res => {
          if (res.code == 200) {
            this.system_type_list = res.data;
          }
        });
    }
  },
  created() {
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    this.getSystemType();

    this.$db.post(this.$db.config.getRegionUrl, { level: 1 }).then(resp => {
      if (resp && resp.code == 200) {
        this.provinceLists = resp.data;
      }
    });

    this.getCity(this.unitForm.province_id);
  }
};
</script>
<style lang="scss" scoped>
table.gridtable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
}
table.gridtable th {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #666666;
  background-color: #dedede;
}
table.gridtable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #666666;
  background-color: #ffffff;
}
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.register_head {
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 600;
  font-family: "Times New Roman", Georgia, Serif;
  color: DimGray;
  padding-bottom: 20px;
  border-bottom: 1px solid #ccc;
  margin-right: 20px;
  margin-bottom: 30px;
  .login {
    font-size: 14px;
    float: right;
    font-family: "微软雅黑";
    font-weight: 300;
    color: #ccc;
  }
}
.center-box {
  .center-list {
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      width: 100%;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 16px;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
  .center-footer {
    width: 100%;
    background-color: #9b0204;
    margin-top: 60px;
    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      padding: 22px 0;

      > span {
        font-size: 14px;
        color: #cb5c5e;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Unit/register.vue